import React, { Component } from "react";
import { PageHeader, Tabs, Alert, Tag, Select, Space, Table, message, Modal, Tooltip } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ButtonItem,
  TableItem,
  SwitchItem,
  SelectItem,
  ModalItem,
  InputItem,
  cuentaMask,
  dineroDisabledMask,
} from "../../../Components/Items";
import SelectEmpresasBiwoItem from "../../../Components/SelectEmpresasBiwoItem";
import ModalEditarPoliza from "../../../Components/ModalEditarPoliza";
import {
  ESTADOS_ENTREGA_VENTA,
  TEXTO_SIN_SUGERIDO,
  tieneSalidasSinEntrega,
  sigueConProblema,
  tipoVenta,
  descargarExcelVentasEstadoIncorrecto,
} from "./exportarVentasEstadoIncorrecto";

const { TabPane } = Tabs;
const { Option } = Select;

// Mismo mapa que polizaPdf.js: el consecutivo numeroTipoTipoPoliza se numera por este codigo.
const TIPOS_POLIZA_GENERICOS = {
  1: "Ingreso",
  2: "Egreso",
  3: "Traslado",
  4: "Nomina",
  5: "Pago",
  6: "Diario",
};

const columnsPolizas = [
  { title: "Póliza ID", dataIndex: "polizaId", key: "polizaId" },
  { title: "Póliza", dataIndex: "numeroTipoPoliza", key: "numeroTipoPoliza", render: (v, r) => `${v || ""} ${r.tipoDePoliza || ""}` },
  { title: "Concepto", dataIndex: "concepto", key: "concepto" },
  { title: "Cargos", dataIndex: "cargos", key: "cargos" },
  { title: "Abonos", dataIndex: "abonos", key: "abonos" },
  { title: "Diferencia", dataIndex: "diferencia", key: "diferencia" },
];

const columnsCuentasContables = [
  { title: "Cargo/Abono ID", dataIndex: "cargoAbonoId", key: "cargoAbonoId" },
  { title: "Póliza ID", dataIndex: "polizaId", key: "polizaId" },
  { title: "Concepto", dataIndex: "concepto", key: "concepto" },
  { title: "Tipo", dataIndex: "tipo", key: "tipo" },
  { title: "Monto", dataIndex: "monto", key: "monto" },
  { title: "Cuenta Contable ID", dataIndex: "cuentaContableId", key: "cuentaContableId" },
];

const columnsEmpresaIdCargosAbonos = [
  { title: "Cargo/Abono ID", dataIndex: "cargoAbonoId", key: "cargoAbonoId" },
  { title: "Póliza ID", dataIndex: "polizaId", key: "polizaId" },
  { title: "Concepto", dataIndex: "concepto", key: "concepto" },
  { title: "Tipo", dataIndex: "tipo", key: "tipo" },
  { title: "Empresa (Cargo/Abono)", dataIndex: "empresaIdCargoAbono", key: "empresaIdCargoAbono" },
  { title: "Empresa (Póliza)", dataIndex: "empresaIdPoliza", key: "empresaIdPoliza", render: (v) => v || "Póliza no encontrada" },
];

const columnsInventario = [
  { title: "Insumo ID", dataIndex: "insumoId", key: "insumoId" },
  { title: "Insumo", dataIndex: "insumoDescripcion", key: "insumoDescripcion" },
  { title: "Proyecto ID", dataIndex: "proyectoId", key: "proyectoId" },
  { title: "Proyecto", dataIndex: "proyectoNombre", key: "proyectoNombre" },
  { title: "Estado", dataIndex: "estadoNombre", key: "estadoNombre" },
  { title: "Entradas - Vendida", dataIndex: "disponibleCalculado", key: "disponibleCalculado" },
  { title: "Inventario", dataIndex: "disponibleInventario", key: "disponibleInventario" },
  { title: "Diferencia", dataIndex: "diferencia", key: "diferencia" },
];

const textoIdChico = (id) => (
  <div style={{ fontFamily: "monospace", fontSize: 10, color: "#999" }}>{id}</div>
);

const columnsSaldoEntradasSalidas = [
  {
    title: "Insumo",
    dataIndex: "insumoDescripcion",
    key: "insumoDescripcion",
    render: (v, r) => (
      <>
        {[r.insumoClave, v].filter(Boolean).join(" - ")}
        {textoIdChico(r.insumoId)}
      </>
    ),
  },
  {
    title: "Almacén",
    dataIndex: "proyectoNombre",
    key: "proyectoNombre",
    render: (v, r) => (
      <>
        {v}
        {textoIdChico(r.proyectoId)}
      </>
    ),
  },
  { title: "Entradas", dataIndex: "entradas", key: "entradas", align: "right" },
  { title: "Salidas", dataIndex: "salidas", key: "salidas", align: "right" },
  {
    title: (
      <Tooltip title="Suma lo vendido de lotes dados de baja y resta las salidas canceladas que no regresaron inventario (cancelaciones antiguas de venta y reemplazos de lote)">
        Ajustes
      </Tooltip>
    ),
    dataIndex: "ajustes",
    key: "ajustes",
    align: "right",
  },
  { title: "Saldo Calculado", dataIndex: "saldoCalculado", key: "saldoCalculado", align: "right" },
  {
    title: "Inventario",
    dataIndex: "inventario",
    key: "inventario",
    align: "right",
    render: (v, r) => (
      <>
        {v}
        <div style={{ fontSize: 11, color: "#999" }}>
          Disp. {r.inventarioDisponible} / Apart. {r.inventarioApartado}
        </div>
      </>
    ),
  },
  { title: "Diferencia", dataIndex: "diferencia", key: "diferencia", align: "right" },
];

const columnsEntregasVsSalidas = [
  { title: "Venta ID", dataIndex: "ventaId", key: "ventaId" },
  { title: "Venta", dataIndex: "serieNumero", key: "serieNumero" },
  { title: "Insumo", dataIndex: "insumoDescripcion", key: "insumoDescripcion" },
  { title: "Clave", dataIndex: "insumoClave", key: "insumoClave" },
  { title: "Entregado", dataIndex: "entregadoRegistrado", key: "entregadoRegistrado" },
  { title: "Salida Registrada", dataIndex: "salidaRegistrada", key: "salidaRegistrada" },
  //Lo que editarRemision regreso al inventario de esas salidas; la diferencia ya es contra la salida menos esto
  { title: "Regresado por Edición", dataIndex: "regresadoEdicionRemision", key: "regresadoEdicionRemision" },
  { title: "Diferencia", dataIndex: "diferencia", key: "diferencia" },
];

const columnsApartadosHuerfanos = [
  { title: "Origen", dataIndex: "origenTipo", key: "origenTipo" },
  { title: "Documento", dataIndex: "origenSerieNumero", key: "origenSerieNumero" },
  { title: "Insumo", dataIndex: "insumoDescripcion", key: "insumoDescripcion" },
  { title: "Clave", dataIndex: "insumoClave", key: "insumoClave" },
  { title: "Apartado en Inventario", dataIndex: "disponibleEnInventario", key: "disponibleEnInventario" },
  { title: "Apartado en Documento", dataIndex: "apartadoRegistradoEnDocumento", key: "apartadoRegistradoEnDocumento" },
  { title: "Motivo", dataIndex: "motivo", key: "motivo" },
];

//Misma llave que el rowKey de la tabla y que el payload de diagnostico/quitarApartadoHuerfano.
const llaveApartado = (fila) => `${fila.origenTipo}_${fila.origenId}_${fila.insumoId}`;

// --- Cuadre del Balance General (diagnosticarCuadreBalance) ---
// Estas tablas usan el Table de antd y no TableItem: TableItem fuerza ellipsis en todas las columnas y el
// detalle de cada motivo es un texto largo que tiene que leerse completo.

const dinero = (valor) => dineroDisabledMask(valor || 0);

const textoDetalle = (texto) => <div style={{ fontSize: 11, color: "#888", whiteSpace: "normal" }}>{texto}</div>;

const columnaPolizaCuadre = {
  title: "Póliza",
  dataIndex: "numeroTipoPoliza",
  key: "numeroTipoPoliza",
  width: 170,
  render: (value, row) => (
    <>
      {value !== null && value !== undefined
        ? `${TIPOS_POLIZA_GENERICOS[row.tipoDePoliza] || "Póliza"} ${value}`
        : "Sin póliza"}
      {row.fechaRegistro && <div style={{ fontSize: 11 }}>{moment(row.fechaRegistro).locale("es").format("L")}</div>}
      {textoIdChico(row.polizaId || "Sin polizaId")}
    </>
  ),
};

const columnaMotivoCuadre = {
  title: "Motivo",
  dataIndex: "motivoNombre",
  key: "motivoNombre",
  render: (value, row) => (
    <>
      <Tag color="red">{value}</Tag>
      {textoDetalle(row.detalle)}
    </>
  ),
};

const columnaDineroCuadre = (title, dataIndex, rojo = false) => ({
  title,
  dataIndex,
  key: dataIndex,
  align: "right",
  width: 130,
  render: (value) => <span style={rojo ? { color: "#cf1322" } : undefined}>{dinero(value)}</span>,
});

const columnsCuadreBalanceConciliacion = [
  {
    title: "Concepto",
    dataIndex: "concepto",
    key: "concepto",
    render: (value, row) => (
      <span style={row.sangria ? { paddingLeft: 24, color: "#888" } : row.total ? { fontWeight: "bold" } : undefined}>{value}</span>
    ),
  },
  {
    title: "Importe",
    dataIndex: "importe",
    key: "importe",
    align: "right",
    width: 160,
    render: (value, row) => (
      <span style={row.total ? { fontWeight: "bold", color: "#cf1322" } : row.sangria ? { color: "#888" } : undefined}>
        {dinero(value)}
      </span>
    ),
  },
];

const columnsCuadreBalanceCuentas = [
  {
    title: "Cuenta",
    dataIndex: "codigo",
    key: "codigo",
    width: 260,
    render: (value, row) => (
      <>
        {[value, row.descripcion].filter(Boolean).join(" - ") || "Cuenta no encontrada"}
        {textoIdChico(row.cuentaContableId)}
      </>
    ),
  },
  {
    title: "Agrupador",
    dataIndex: "agrupadorCodigo",
    key: "agrupadorCodigo",
    width: 170,
    render: (value, row) => (
      <>
        {value}
        {textoDetalle([row.tipo, row.naturaleza].filter(Boolean).join(" / "))}
      </>
    ),
  },
  columnaDineroCuadre("Cargos", "cargos"),
  columnaDineroCuadre("Abonos", "abonos"),
  columnaDineroCuadre("Efecto en el balance", "efecto", true),
  columnaMotivoCuadre,
];

const columnsCuadreBalanceSinPoliza = [
  columnaPolizaCuadre,
  { title: "Concepto", dataIndex: "concepto", key: "concepto", width: 220 },
  columnaMotivoCuadre,
  { title: "Movimientos", dataIndex: "movimientos", key: "movimientos", align: "right", width: 110 },
  columnaDineroCuadre("Diferencia", "diferencia", true),
];

const columnsCuadreBalancePorFecha = [
  columnaPolizaCuadre,
  { title: "Concepto", dataIndex: "concepto", key: "concepto", width: 220 },
  {
    title: "Días de sus movimientos",
    dataIndex: "dias",
    key: "dias",
    render: (dias) =>
      (dias || []).map((dia) => (
        <div key={dia.dia} style={{ fontSize: 12 }}>
          {dia.dia}: {dinero(dia.diferencia)}{" "}
          <span style={{ color: "#888" }}>(acumulado {dinero(dia.acumulado)})</span>
        </div>
      )),
  },
  columnaDineroCuadre("Descuadre al cortar", "maximoDescuadreParcial", true),
];

const columnsCuadreBalanceProyectos = [
  {
    title: "Proyecto",
    dataIndex: "proyectoNombre",
    key: "proyectoNombre",
    render: (value, row) => (
      <>
        {value}
        {textoIdChico(row.proyectoId)}
      </>
    ),
  },
  columnaDineroCuadre("Cargos − Abonos", "diferencia", true),
];

const columnsCuadreBalancePorProyecto = [
  columnaPolizaCuadre,
  { title: "Concepto", dataIndex: "concepto", key: "concepto", width: 220 },
  {
    title: "Proyectos descuadrados",
    dataIndex: "proyectos",
    key: "proyectos",
    render: (proyectos) =>
      (proyectos || []).map((proyecto) => (
        <div key={String(proyecto.proyectoId)} style={{ fontSize: 12 }}>
          {proyecto.proyectoNombre}: <span style={{ color: "#cf1322" }}>{dinero(proyecto.diferencia)}</span>
        </div>
      )),
  },
];

const TablaCuadreBalance = (props) => (
  <Table size="small" pagination={false} scroll={{ x: 900 }} style={{ marginBottom: 12 }} {...props} />
);

const SeccionCuadreBalance = ({ cuadreBalance, onCrearCuentasPadre, creandoCuentasPadre }) => {
  if (!cuadreBalance) return null;
  //Ramas sin cuenta de nivel 1 (p. ej. la 210-01-001 que crea el asistente de nomina sin la 210): se arreglan
  //creando los padres que faltan. No aplica a un nivel 1 que existe con null en sus niveles.
  const haySinCuentaNivel1 = cuadreBalance.cuentas.some((cuenta) => cuenta.motivo === "sinCuentaNivel1");
  const { balance, conciliacion } = cuadreBalance;
  const desglose = conciliacion.desgloseDescuadreMovimientos || {};

  const filasConciliacion = [
    { key: "movimientos", concepto: "Descuadre de movimientos (todos los cargos − todos los abonos)", importe: conciliacion.descuadreMovimientos },
    { key: "noVigentes", concepto: "de pólizas canceladas, inexistentes o de otra empresa", importe: desglose.polizasNoVigentes, sangria: true },
    { key: "estado", concepto: "de movimientos con estado distinto de 0 y 1", importe: desglose.estadoMovimientoNoReconocido, sangria: true },
    {
      key: "vigentes",
      concepto: `de pólizas vigentes descuadradas (${desglose.cantidadPolizasVigentesDescuadradas || 0}, ver "Pólizas Cuadradas")`,
      importe: desglose.polizasVigentesDescuadradas,
      sangria: true,
    },
    { key: "residuo", concepto: "redondeo / otros", importe: desglose.residuo, sangria: true },
    {
      key: "fuera",
      concepto: "Movimientos que el balance no lee (cuenta cancelada, sin agrupador SAT o inexistente)",
      importe: conciliacion.movimientosFueraDelBalance,
    },
    {
      key: "estructura",
      concepto: "Estructura del catálogo (sin cuenta de nivel 1, nivel 1 duplicado, naturaleza contraria, tipo no reconocido)",
      importe: conciliacion.estructuraCatalogo,
    },
    { key: "diferencia", concepto: "Diferencia del balance (Activo − Pasivo − Capital)", importe: conciliacion.diferenciaBalance, total: true },
  ];

  const subtitulo = (texto, ayuda) => (
    <h4 style={{ marginTop: 16 }}>
      {texto}
      {ayuda && <div style={{ fontSize: 12, fontWeight: "normal", color: "#888" }}>{ayuda}</div>}
    </h4>
  );
  const recortado = (mostradas, total) =>
    total > mostradas ? (
      <div style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>
        Mostrando las {mostradas} de mayor monto de {total}.
      </div>
    ) : null;

  return (
    <div style={{ marginBottom: 20 }}>
      {balance.diferencia === 0 ? (
        <Alert
          type="success"
          showIcon
          message={`El balance cuadra: Activo ${dinero(balance.activo)} = Pasivo + Capital ${dinero(balance.pasivoMasCapital)} (${cuadreBalance.totalMovimientosRevisados} movimientos en ${cuadreBalance.totalCuentasRevisadas} cuentas)`}
          description="Calculado como el Estado de Posición Financiera, a todas las fechas y sin filtros."
        />
      ) : (
        <>
          <Alert
            type="error"
            showIcon
            message={`El balance descuadra por ${dinero(balance.diferencia)}`}
            description={`Activo ${dinero(balance.activo)} vs Pasivo ${dinero(balance.pasivo)} + Capital ${dinero(balance.capital)} + Utilidad del ejercicio ${dinero(balance.utilidad)} = ${dinero(balance.pasivoMasCapital)}. Calculado como el Estado de Posición Financiera, a todas las fechas y sin filtros.`}
            style={{ marginBottom: 8 }}
          />
          <TablaCuadreBalance
            showHeader={false}
            rowKey="key"
            dataSource={filasConciliacion}
            columns={columnsCuadreBalanceConciliacion}
            scroll={undefined}
            style={{ maxWidth: 900, marginBottom: 12 }}
          />
        </>
      )}

      {cuadreBalance.montoNoNumerico > 0 && (
        <Alert
          type="warning"
          showIcon
          style={{ marginTop: 8 }}
          message={`${cuadreBalance.montoNoNumerico} movimiento(s) con un monto que no es número: el reporte los concatena como texto en lugar de sumarlos`}
        />
      )}

      {cuadreBalance.cuentas.length > 0 && (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            {subtitulo(
              "Cuentas que descuadran el balance",
              "El efecto es lo que cada cuenta mueve la diferencia Activo − Pasivo − Capital."
            )}
            {haySinCuentaNivel1 && onCrearCuentasPadre && (
              <ButtonItem blanco loading={creandoCuentasPadre} onClick={onCrearCuentasPadre}>
                Crear cuentas padre faltantes
              </ButtonItem>
            )}
          </div>
          <TablaCuadreBalance
            rowKey={(r) => String(r.cuentaContableId)}
            dataSource={cuadreBalance.cuentas}
            columns={columnsCuadreBalanceCuentas}
          />
        </>
      )}

      {cuadreBalance.movimientosSinPolizaVigente.length > 0 && (
        <>
          {subtitulo(
            "Movimientos que el chequeo de pólizas no revisa",
            "Movimientos vigentes que el balance suma pero que \"Pólizas Cuadradas\" no ve."
          )}
          <TablaCuadreBalance
            rowKey={(r) => String(r.polizaId)}
            dataSource={cuadreBalance.movimientosSinPolizaVigente}
            columns={columnsCuadreBalanceSinPoliza}
          />
        </>
      )}

      {cuadreBalance.polizasPorFecha.length > 0 && (
        <>
          {subtitulo(
            "Pólizas con movimientos en días distintos",
            "El balance filtra por la fecha de cada movimiento: con una fecha de corte entre esos días ve sólo una parte de la póliza y descuadra."
          )}
          <TablaCuadreBalance
            rowKey={(r) => String(r.polizaId)}
            dataSource={cuadreBalance.polizasPorFecha}
            columns={columnsCuadreBalancePorFecha}
          />
          {recortado(cuadreBalance.polizasPorFecha.length, cuadreBalance.totalPolizasPorFecha)}
        </>
      )}

      {cuadreBalance.proyectosDescuadrados.length > 0 && (
        <>
          {subtitulo(
            "Proyectos descuadrados",
            "Cargos menos abonos de cada proyecto: el balance filtrado por ese proyecto (o visto por un usuario con proyectos limitados) arrastra esta diferencia."
          )}
          <TablaCuadreBalance
            rowKey={(r) => String(r.proyectoId)}
            dataSource={cuadreBalance.proyectosDescuadrados}
            columns={columnsCuadreBalanceProyectos}
            scroll={undefined}
            style={{ maxWidth: 700, marginBottom: 12 }}
          />
        </>
      )}

      {cuadreBalance.polizasPorProyecto.length > 0 && (
        <>
          {subtitulo("Pólizas que cuadran en total pero no por proyecto")}
          <TablaCuadreBalance
            rowKey={(r) => String(r.polizaId)}
            dataSource={cuadreBalance.polizasPorProyecto}
            columns={columnsCuadreBalancePorProyecto}
          />
          {recortado(cuadreBalance.polizasPorProyecto.length, cuadreBalance.totalPolizasPorProyecto)}
        </>
      )}
    </div>
  );
};

class EjecutarAhora extends Component {
  state = {
    empresaId: null,
    loading: false,
    resultado: null,
    loadingApartados: false,
    quitandoApartado: null,
    creandoCuentasPadre: false,
  };

  //Crea las cuentas padre que faltan y refresca solo la seccion del cuadre del balance con lo que responde el
  //endpoint (no vuelve a correr diagnostico/ejecutar, que corre todos los chequeos y vacia la pantalla).
  crearCuentasPadre() {
    if (!this.state.empresaId) {
      message.error("Selecciona una empresa");
      return;
    }
    Modal.confirm({
      title: "Crear cuentas padre faltantes",
      content:
        "Se crearán las cuentas de nivel 1 y 2 que le faltan al catálogo (por ejemplo la 210 de una 210-01-001), con el agrupador SAT de su código. No se toca ningún movimiento.",
      okText: "Crear cuentas",
      cancelText: "Cancelar",
      onOk: () => {
        this.setState({ creandoCuentasPadre: true });
        return axios
          .post(
            "diagnostico/crearCuentasPadreFaltantes",
            { empresaId: this.state.empresaId },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            this.setState({ creandoCuentasPadre: false });
            if (res.data.success !== 2) {
              message.error(res.data.message || "No se pudieron crear las cuentas padre");
              return;
            }

            const creadas = res.data.creadas || [];
            const omitidas = res.data.omitidas || [];
            if (creadas.length) {
              message.success(
                `Se crearon ${creadas.length} cuenta(s): ${creadas.map((cuenta) => `${cuenta.codigo} ${cuenta.descripcion}`).join(", ")}`,
                8
              );
            } else {
              message.info("No faltaba ninguna cuenta padre");
            }
            if (omitidas.length) {
              message.warning(
                `No se pudieron crear ${omitidas.length} cuenta(s) porque su cuenta hija no tiene agrupador SAT: ${omitidas.map((omitida) => omitida.codigo).join(", ")}`,
                8
              );
            }

            this.setState((state) => ({
              resultado: state.resultado ? { ...state.resultado, cuadreBalance: res.data.cuadreBalance } : state.resultado,
            }));
          })
          .catch(() => {
            this.setState({ creandoCuentasPadre: false });
            message.error("No se pudieron crear las cuentas padre");
          });
      },
    });
  }

  ejecutar() {
    if (!this.state.empresaId) {
      message.error("Selecciona una empresa");
      return;
    }
    this.setState({ loading: true, resultado: null });
    axios
      .post(
        "diagnostico/ejecutar",
        { empresaId: this.state.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ resultado: res.data });
        } else {
          message.error(res.data.message || "No se pudo ejecutar el diagnóstico");
        }
      });
  }

  //Quita solo la fila liberada del resultado que ya esta en memoria. A proposito no se vuelve a
  //llamar diagnostico/ejecutar: ese endpoint corre los seis chequeos (los de inventario y entregas
  //son los caros) y ademas vacia la pantalla completa. Para reconfirmar contra la base esta el
  //boton "Volver a revisar", que corre solo el chequeo de apartados.
  quitarFilaApartadoDelResultado(row) {
    this.setState((state) => {
      const seccion = state.resultado?.apartadosHuerfanos;
      if (!seccion) return null;

      const restantes = (seccion.apartadosHuerfanos || []).filter(
        (fila) =>
          !(
            fila.origenTipo === row.origenTipo &&
            String(fila.origenId) === String(row.origenId) &&
            String(fila.insumoId) === String(row.insumoId)
          )
      );

      return {
        resultado: {
          ...state.resultado,
          apartadosHuerfanos: {
            ...seccion,
            ok: restantes.length === 0,
            apartadosHuerfanos: restantes,
          },
        },
      };
    });
  }

  quitarApartado(row) {
    Modal.confirm({
      title: "Quitar apartado",
      content: `¿Seguro que quieres liberar el apartado de "${row.insumoDescripcion}" en ${row.origenTipo} ${row.origenSerieNumero}? Se usará la misma fecha y usuario de la entrada original.`,
      okText: "Quitar apartado",
      okButtonProps: { danger: true },
      cancelText: "Cancelar",
      onOk: () => {
        this.setState({ quitandoApartado: llaveApartado(row) });
        return axios
          .post(
            "diagnostico/quitarApartadoHuerfano",
            {
              empresaId: this.state.empresaId,
              origenTipo: row.origenTipo,
              origenId: row.origenId,
              insumoId: row.insumoId,
            },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            this.setState({ quitandoApartado: null });
            if (res.data.success !== 2) {
              message.error(res.data.message || "No se pudo quitar el apartado");
              return;
            }

            const entradasCreadas = res.data.totalEntradasCreadas ?? 0;
            const salidasCreadas = res.data.totalSalidasCreadas ?? 0;

            //quitarApartadosDeInventario se traga sus propios errores y devuelve arreglos vacios,
            //asi que el controlador responde success 2 igual. Los contadores en cero son la unica
            //senal de que no se libero nada: ahi se deja la fila para que se pueda reintentar.
            if (entradasCreadas === 0 && salidasCreadas === 0) {
              message.warning(
                "No se liberó ningún movimiento, el apartado sigue pendiente. Vuelve a revisar la sección."
              );
              return;
            }

            message.success(
              `Apartado liberado: se crearon ${entradasCreadas} entrada(s) y ${salidasCreadas} salida(s)`
            );
            this.quitarFilaApartadoDelResultado(row);
          })
          //Sin esto un error de red dejaria quitandoApartado fijo y los demas botones deshabilitados
          .catch(() => {
            this.setState({ quitandoApartado: null });
            message.error("No se pudo quitar el apartado");
          });
      },
    });
  }

  //Solo el chequeo de apartados huerfanos, para reconfirmar la seccion sin re-disparar los otros cinco.
  revisarApartados() {
    if (!this.state.empresaId) {
      message.error("Selecciona una empresa");
      return;
    }
    this.setState({ loadingApartados: true });
    axios
      .post(
        "diagnostico/apartadosHuerfanos",
        { empresaId: this.state.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingApartados: false });
        if (res.data.success === 2) {
          //El endpoint devuelve la seccion spreadeada (igual que polizasDescuadradas), se re-anida
          //para que encaje con la forma que arma diagnostico/ejecutar.
          this.setState((state) => ({
            resultado: {
              ...state.resultado,
              apartadosHuerfanos: {
                ok: res.data.ok,
                totalApartadosVigentesRevisados: res.data.totalApartadosVigentesRevisados,
                apartadosHuerfanos: res.data.apartadosHuerfanos,
              },
            },
          }));
        } else {
          message.error(res.data.message || "No se pudieron consultar los apartados huérfanos");
        }
      })
      .catch(() => {
        this.setState({ loadingApartados: false });
        message.error("No se pudieron consultar los apartados huérfanos");
      });
  }

  getColumnsApartadosHuerfanos() {
    return [
      ...columnsApartadosHuerfanos,
      {
        title: "Acción",
        key: "accion",
        render: (_, row) => {
          const llave = llaveApartado(row);
          return (
            <ButtonItem
              danger
              size="small"
              loading={this.state.quitandoApartado === llave}
              disabled={!!this.state.quitandoApartado && this.state.quitandoApartado !== llave}
              onClick={() => this.quitarApartado(row)}
            >
              Quitar apartado
            </ButtonItem>
          );
        },
      },
    ];
  }

  descargarExcelApartadosHuerfanos() {
    const filas = this.state.resultado?.apartadosHuerfanos?.apartadosHuerfanos || [];

    //Acumula por proyecto+insumo: varias ventas/pedidos huerfanos pueden compartir el mismo
    //proyecto+insumo, y el disponible/apartado actual del proyecto es el mismo para todas esas
    //filas (no se suma), solo se suma la cantidad huerfana a liberar entre esas filas.
    const acumuladoPorClave = new Map();
    filas.forEach((fila) => {
      const clave = `${fila.proyectoId}_${fila.insumoId}`;
      const existente = acumuladoPorClave.get(clave);
      if (existente) {
        existente.apartadoHuerfanoALiberar += fila.disponibleEnInventario || 0;
        existente.origenes += 1;
      } else {
        acumuladoPorClave.set(clave, {
          proyecto: fila.proyectoNombre,
          insumo: fila.insumoDescripcion,
          clave: fila.insumoClave,
          disponibleActual: fila.disponibleActualProyecto || 0,
          apartadoActual: fila.apartadoActualProyecto || 0,
          apartadoHuerfanoALiberar: fila.disponibleEnInventario || 0,
          origenes: 1,
        });
      }
    });

    const datosDescargar = [...acumuladoPorClave.values()].map((valor) => ({
      Proyecto: valor.proyecto,
      Insumo: valor.insumo,
      Clave: valor.clave,
      "Apartados Huérfanos (orígenes)": valor.origenes,
      "Disponible Actual": valor.disponibleActual,
      "Apartado Actual (Total)": valor.apartadoActual,
      "Apartado Huérfano a Liberar": valor.apartadoHuerfanoALiberar,
      "Disponible Si Se Libera": valor.disponibleActual + valor.apartadoHuerfanoALiberar,
      "Apartado Si Se Libera": valor.apartadoActual - valor.apartadoHuerfanoALiberar,
    }));

    const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Apartados Huerfanos");
    XLSX.writeFile(workbook, `Apartados_Huerfanos_${moment().locale("es").format("L")}.xlsx`);
  }

  render() {
    const { resultado } = this.state;
    return (
      <div style={{ padding: 20 }}>
        <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 20 }}>
          <SelectEmpresasBiwoItem
            style={{ width: 320 }}
            placeholder="Seleccionar empresa"
            onChange={(empresaId) => this.setState({ empresaId })}
          />
          <ButtonItem loading={this.state.loading} onClick={this.ejecutar.bind(this)}>
            Ejecutar Diagnóstico
          </ButtonItem>
        </div>

        {resultado && (
          <>
            <h3>Pólizas Cuadradas</h3>
            {resultado.polizas.ok ? (
              <Alert
                type="success"
                showIcon
                message={`Todas las pólizas cuadran (${resultado.polizas.totalPolizasRevisadas} revisadas)`}
                style={{ marginBottom: 20 }}
              />
            ) : (
              <TableItem
                style={{ marginBottom: 20 }}
                size="small"
                pagination={false}
                rowKey="polizaId"
                dataSource={resultado.polizas.descuadradas}
                columns={columnsPolizas}
              />
            )}

            <h3>Entradas vs Inventario</h3>
            {resultado.inventario.ok ? (
              <Alert
                type="success"
                showIcon
                message={`El inventario coincide con las entradas (${resultado.inventario.totalInsumosProyectosRevisados} insumo/proyecto revisados)`}
              />
            ) : (
              <TableItem
                size="small"
                pagination={false}
                rowKey={(r) => `${r.insumoId}_${r.proyectoId}_${r.estado}`}
                dataSource={resultado.inventario.discrepancias}
                columns={columnsInventario}
              />
            )}

            <h3>Entradas − Salidas vs Inventario</h3>
            {resultado.saldoEntradasSalidas?.ok ? (
              <Alert
                type="success"
                showIcon
                message={`El saldo de entradas menos salidas coincide con el inventario (${resultado.saldoEntradasSalidas.totalInsumosProyectosRevisados} insumo/almacén revisados)`}
              />
            ) : (
              <TableItem
                size="small"
                pagination={false}
                rowKey={(r) => `${r.insumoId}_${r.proyectoId}`}
                dataSource={resultado.saldoEntradasSalidas?.discrepancias || []}
                columns={columnsSaldoEntradasSalidas}
              />
            )}

            <h3>Cuentas Contables de Cargos/Abonos</h3>
            {resultado.cuentasContables.ok ? (
              <Alert
                type="success"
                showIcon
                message={`Todos los cargos/abonos tienen cuenta contable válida (${resultado.cuentasContables.totalCargosAbonosRevisados} revisados)`}
              />
            ) : (
              <TableItem
                size="small"
                pagination={false}
                rowKey="cargoAbonoId"
                dataSource={resultado.cuentasContables.faltantes}
                columns={columnsCuentasContables}
              />
            )}

            <h3>Empresa de Cargos/Abonos</h3>
            {resultado.empresaIdCargosAbonos.ok ? (
              <Alert
                type="success"
                showIcon
                message={`Todos los cargos/abonos corresponden a la empresa de su póliza (${resultado.empresaIdCargosAbonos.totalCargosAbonosRevisados} revisados)`}
              />
            ) : (
              <TableItem
                size="small"
                pagination={false}
                rowKey="cargoAbonoId"
                dataSource={resultado.empresaIdCargosAbonos.noCorresponden}
                columns={columnsEmpresaIdCargosAbonos}
              />
            )}

            <h3>Cuadre del Balance General</h3>
            <SeccionCuadreBalance
              cuadreBalance={resultado.cuadreBalance}
              onCrearCuentasPadre={() => this.crearCuentasPadre()}
              creandoCuentasPadre={this.state.creandoCuentasPadre}
            />

            <h3>Entregas de Venta vs Salidas</h3>
            {resultado.entregasVsSalidas.ok ? (
              <Alert
                type="success"
                showIcon
                message={`Todas las entregas tienen su salida registrada (${resultado.entregasVsSalidas.totalLineasEntregaRevisadas} líneas revisadas)`}
              />
            ) : (
              <TableItem
                size="small"
                pagination={false}
                rowKey={(r) => `${r.ventaId}_${r.insumoId}`}
                dataSource={resultado.entregasVsSalidas.discrepanciasEntregas}
                columns={columnsEntregasVsSalidas}
              />
            )}

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <h3>Apartados Huérfanos</h3>
              <Space>
                <ButtonItem
                  blanco
                  loading={this.state.loadingApartados}
                  onClick={() => this.revisarApartados()}
                >
                  Volver a revisar
                </ButtonItem>
                {resultado.apartadosHuerfanos.apartadosHuerfanos?.length > 0 && (
                  <ButtonItem
                    blanco
                    icon={<FileExcelOutlined />}
                    onClick={() => this.descargarExcelApartadosHuerfanos()}
                  >
                    Descargar Excel
                  </ButtonItem>
                )}
              </Space>
            </div>
            {resultado.apartadosHuerfanos.ok ? (
              <Alert
                type="success"
                showIcon
                message={`Todos los apartados corresponden a una venta/pedido vigente (${resultado.apartadosHuerfanos.totalApartadosVigentesRevisados} revisados)`}
              />
            ) : (
              <TableItem
                size="small"
                pagination={false}
                loading={this.state.loadingApartados}
                rowKey={llaveApartado}
                dataSource={resultado.apartadosHuerfanos.apartadosHuerfanos}
                columns={this.getColumnsApartadosHuerfanos()}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

class ConfigurarCron extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    guardando: false,
    tipoFrecuencia: "diario",
    empresasSeleccionadas: [],
    pickerKey: 0,
  };

  componentDidMount() {
    this.cargarConfiguracion();
  }

  cargarConfiguracion() {
    this.setState({ loading: true });
    axios
      .post("diagnostico/obtenerConfiguracion", {}, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          const { configuracion, empresas } = res.data;
          this.setState({
            tipoFrecuencia: configuracion.frecuencia?.tipo || "diario",
            empresasSeleccionadas: empresas || [],
          });
          this.formRef.current?.setFieldsValue({
            activa: configuracion.activa,
            tipo: configuracion.frecuencia?.tipo || "diario",
            hora: configuracion.frecuencia?.hora ?? 6,
            diaSemana: configuracion.frecuencia?.diaSemana ?? 0,
            correosDestinatarios: configuracion.correosDestinatarios,
          });
        }
      });
  }

  agregarEmpresa(empresaId, empresa) {
    if (!empresa) return;
    this.setState((prevState) => ({
      empresasSeleccionadas: prevState.empresasSeleccionadas.some((e) => e._id === empresa._id)
        ? prevState.empresasSeleccionadas
        : [...prevState.empresasSeleccionadas, empresa],
      pickerKey: prevState.pickerKey + 1,
    }));
  }

  quitarEmpresa(empresaId) {
    this.setState((prevState) => ({
      empresasSeleccionadas: prevState.empresasSeleccionadas.filter((e) => e._id !== empresaId),
    }));
  }

  guardar() {
    const values = this.formRef.current?.getFieldsValue();
    this.setState({ guardando: true });
    axios
      .post(
        "diagnostico/guardarConfiguracion",
        {
          activa: values.activa,
          frecuencia: { tipo: values.tipo, hora: values.hora, diaSemana: values.diaSemana },
          empresasIds: this.state.empresasSeleccionadas.map((e) => e._id),
          correosDestinatarios: values.correosDestinatarios,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          message.success("Configuración guardada");
        } else {
          message.error(res.data.message || "No se pudo guardar la configuración");
        }
      });
  }

  render() {
    return (
      <div style={{ padding: 20, maxWidth: 640 }}>
        <Form ref={this.formRef} name="configuracionDiagnostico" layout="vertical">
          <FormItem name="activa" label="Diagnóstico automático" valuePropName="checked">
            <SwitchItem />
          </FormItem>

          <FormItem name="tipo" label="Frecuencia">
            <SelectItem onChange={(tipo) => this.setState({ tipoFrecuencia: tipo })}>
              <Option value="diario">Diario</Option>
              <Option value="semanal">Semanal</Option>
            </SelectItem>
          </FormItem>

          <FormItem name="hora" label="Hora (0-23, hora CDMX)">
            <SelectItem>
              {Array.from({ length: 24 }, (_, hora) => (
                <Option key={hora} value={hora}>{hora}:00</Option>
              ))}
            </SelectItem>
          </FormItem>

          {this.state.tipoFrecuencia === "semanal" && (
            <FormItem name="diaSemana" label="Día de la semana">
              <SelectItem>
                <Option value={0}>Domingo</Option>
                <Option value={1}>Lunes</Option>
                <Option value={2}>Martes</Option>
                <Option value={3}>Miércoles</Option>
                <Option value={4}>Jueves</Option>
                <Option value={5}>Viernes</Option>
                <Option value={6}>Sábado</Option>
              </SelectItem>
            </FormItem>
          )}

          <FormItem label="Empresas incluidas">
            <SelectEmpresasBiwoItem
              key={this.state.pickerKey}
              placeholder="Buscar y agregar empresa"
              onChange={this.agregarEmpresa.bind(this)}
            />
            <div style={{ marginTop: 10 }}>
              <Space wrap>
                {this.state.empresasSeleccionadas.map((empresa) => (
                  <Tag key={empresa._id} closable onClose={() => this.quitarEmpresa(empresa._id)}>
                    {empresa.nombre}
                  </Tag>
                ))}
              </Space>
            </div>
          </FormItem>

          <FormItem name="correosDestinatarios" label="Correos destinatarios del informe">
            <Select mode="tags" placeholder="Agregar correo y presionar Enter" tokenSeparators={[",", " "]} />
          </FormItem>

          <ButtonItem loading={this.state.guardando} onClick={this.guardar.bind(this)}>
            Guardar
          </ButtonItem>
        </Form>
      </div>
    );
  }
}

class ConfigurarCronInventario extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    guardando: false,
    empresasSeleccionadas: [],
    pickerKey: 0,
  };

  componentDidMount() {
    this.cargarConfiguracion();
  }

  cargarConfiguracion() {
    this.setState({ loading: true });
    axios
      .post("diagnostico/obtenerConfiguracionInventario", {}, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          const { configuracion, empresas } = res.data;
          this.setState({
            empresasSeleccionadas: empresas || [],
          });
          this.formRef.current?.setFieldsValue({
            activa: configuracion.activa,
            horasExcluidas: configuracion.horasExcluidas || [],
            correosDestinatarios: configuracion.correosDestinatarios,
          });
        }
      });
  }

  agregarEmpresa(empresaId, empresa) {
    if (!empresa) return;
    this.setState((prevState) => ({
      empresasSeleccionadas: prevState.empresasSeleccionadas.some((e) => e._id === empresa._id)
        ? prevState.empresasSeleccionadas
        : [...prevState.empresasSeleccionadas, empresa],
      pickerKey: prevState.pickerKey + 1,
    }));
  }

  quitarEmpresa(empresaId) {
    this.setState((prevState) => ({
      empresasSeleccionadas: prevState.empresasSeleccionadas.filter((e) => e._id !== empresaId),
    }));
  }

  guardar() {
    const values = this.formRef.current?.getFieldsValue();
    this.setState({ guardando: true });
    axios
      .post(
        "diagnostico/guardarConfiguracionInventario",
        {
          activa: values.activa,
          horasExcluidas: values.horasExcluidas || [],
          empresasIds: this.state.empresasSeleccionadas.map((e) => e._id),
          correosDestinatarios: values.correosDestinatarios,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          message.success("Configuración guardada");
        } else {
          message.error(res.data.message || "No se pudo guardar la configuración");
        }
      });
  }

  render() {
    return (
      <div style={{ padding: 20, maxWidth: 640 }}>
        <Form ref={this.formRef} name="configuracionDiagnosticoInventario" layout="vertical">
          <FormItem name="activa" label="Diagnóstico de inventario automático" valuePropName="checked">
            <SwitchItem />
          </FormItem>

          <FormItem name="horasExcluidas" label="Horas en las que NO quieres recibir el informe (opcional, hora CDMX)">
            <SelectItem mode="multiple" placeholder="Ninguna (te informará cada hora)" allowClear>
              {Array.from({ length: 24 }, (_, hora) => (
                <Option key={hora} value={hora}>{hora}:00</Option>
              ))}
            </SelectItem>
          </FormItem>

          <FormItem label="Empresas incluidas">
            <SelectEmpresasBiwoItem
              key={this.state.pickerKey}
              placeholder="Buscar y agregar empresa"
              onChange={this.agregarEmpresa.bind(this)}
            />
            <div style={{ marginTop: 10 }}>
              <Space wrap>
                {this.state.empresasSeleccionadas.map((empresa) => (
                  <Tag key={empresa._id} closable onClose={() => this.quitarEmpresa(empresa._id)}>
                    {empresa.nombre}
                  </Tag>
                ))}
              </Space>
            </div>
          </FormItem>

          <FormItem name="correosDestinatarios" label="Correos destinatarios del informe">
            <Select mode="tags" placeholder="Agregar correo y presionar Enter" tokenSeparators={[",", " "]} />
          </FormItem>

          <ButtonItem loading={this.state.guardando} onClick={this.guardar.bind(this)}>
            Guardar
          </ButtonItem>
        </Form>
      </div>
    );
  }
}

/*
  Cuadre de las polizas que el balanceo automatico (validarCargosAbonos) no pudo cerrar y
  dejo guardadas descuadradas. Dos caminos por renglon:

  - "Cuadrar": agrega un solo renglon de ajuste por la diferencia (diagnostico/cuadrarPoliza).
    Es el camino recomendado; no pasa por editarPolizaManual, que cuando un renglon apunta a la
    cuenta de un banco genera un Pago y mueve el saldo por el monto completo del renglon.
  - "Editar": abre la poliza completa en el mismo formulario de /panel/editarPolizaManual,
    pasandole el empresaId del cliente (aqui la empresa de la sesion es la del usuario Biwo).
*/
class CuadrarPolizas extends Component {
  state = {
    empresaId: null,
    loading: false,
    resultado: null,
    objetoCuentasContables: null,
    modalCuadrar: false,
    polizaCuadrar: null,
    guardando: false,
    modalEditar: false,
    polizaEditarId: null,
  };

  onChangeEmpresa(empresaId) {
    this.setState({ empresaId, resultado: null, objetoCuentasContables: null });
    if (!empresaId) return;
    this.consultarPolizas(empresaId);
    this.consultarCuentasContables(empresaId);
  }

  consultarPolizas(empresaIdParametro) {
    const empresaId = empresaIdParametro || this.state.empresaId;
    if (!empresaId) {
      message.error("Selecciona una empresa");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "diagnostico/polizasDescuadradas",
        { empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ resultado: res.data });
        } else {
          message.error(res.data.message || "No se pudieron consultar las pólizas");
        }
      });
  }

  consultarCuentasContables(empresaId) {
    axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) return;
        this.setState({
          objetoCuentasContables: res.data.map((value) => (
            <Option value={value._id} key={value._id}>
              {cuentaMask(
                value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5
              ) +
                " - " +
                value.descripcion}
            </Option>
          )),
        });
      });
  }

  abrirCuadrar(row) {
    this.setState({ modalCuadrar: true, polizaCuadrar: row });
  }

  cerrarCuadrar() {
    this.setState({ modalCuadrar: false, polizaCuadrar: null });
  }

  cuadrarPoliza(values) {
    const { polizaCuadrar, empresaId } = this.state;
    if (!polizaCuadrar) return;
    this.setState({ guardando: true });
    axios
      .post(
        "diagnostico/cuadrarPoliza",
        {
          empresaId,
          polizaId: polizaCuadrar.polizaId,
          cuentaContableId: values.cuentaContableId,
          concepto: values.concepto,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          message.success(res.data.message || "Póliza cuadrada");
          this.cerrarCuadrar();
          this.consultarPolizas();
        } else {
          message.error(res.data.message || "No se pudo cuadrar la póliza");
        }
      });
  }

  getColumns() {
    return [
      {
        title: "Póliza",
        dataIndex: "numeroTipoPoliza",
        key: "numeroTipoPoliza",
        render: (value, row) =>
          `${TIPOS_POLIZA_GENERICOS[row.tipoDePoliza] || "Póliza"} ${value || ""}${
            row.numeroTipoTipoPoliza ? ` / ${row.numeroTipoTipoPoliza}` : ""
          }`,
      },
      {
        title: "Fecha",
        dataIndex: "fechaRegistro",
        key: "fechaRegistro",
        render: (value) => (value ? moment(value).locale("es").format("L") : ""),
      },
      { title: "Concepto", dataIndex: "concepto", key: "concepto" },
      {
        title: "Origen",
        dataIndex: "manual",
        key: "manual",
        render: (value) =>
          value ? <Tag color="blue">Manual</Tag> : <Tag color="orange">Automática</Tag>,
      },
      {
        title: "Cargos",
        dataIndex: "cargos",
        key: "cargos",
        align: "right",
        render: (value) => dineroDisabledMask(value),
      },
      {
        title: "Abonos",
        dataIndex: "abonos",
        key: "abonos",
        align: "right",
        render: (value) => dineroDisabledMask(value),
      },
      {
        title: "Diferencia",
        dataIndex: "diferencia",
        key: "diferencia",
        align: "right",
        render: (value) => (
          <span style={{ color: "#cf1322" }}>
            {dineroDisabledMask(value)} {value > 0 ? "(faltan abonos)" : "(faltan cargos)"}
          </span>
        ),
      },
      {
        // dataIndex "accion" exacto: si no, TableItem le mete ellipsis a la celda.
        title: "Acciones",
        dataIndex: "accion",
        key: "accion",
        render: (_, row) => (
          <Space>
            <ButtonItem size="small" onClick={() => this.abrirCuadrar(row)}>
              Cuadrar
            </ButtonItem>
            <ButtonItem
              blanco
              size="small"
              onClick={() => this.setState({ modalEditar: true, polizaEditarId: row.polizaId })}
            >
              Editar
            </ButtonItem>
          </Space>
        ),
      },
    ];
  }

  render() {
    const { resultado, polizaCuadrar } = this.state;
    return (
      <div style={{ padding: 20 }}>
        <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 20 }}>
          <SelectEmpresasBiwoItem
            style={{ width: 320 }}
            placeholder="Seleccionar empresa"
            onChange={(empresaId) => this.onChangeEmpresa(empresaId)}
          />
          <ButtonItem
            loading={this.state.loading}
            disabled={!this.state.empresaId}
            onClick={() => this.consultarPolizas()}
          >
            Consultar
          </ButtonItem>
        </div>

        {resultado &&
          (resultado.ok ? (
            <Alert
              type="success"
              showIcon
              message={`Todas las pólizas cuadran (${resultado.totalPolizasRevisadas} revisadas)`}
            />
          ) : (
            <>
              <Alert
                type="warning"
                showIcon
                message={`${resultado.descuadradas.length} póliza(s) descuadrada(s) de ${resultado.totalPolizasRevisadas} revisadas`}
                description="Cuadrar agrega un solo renglón de ajuste por la diferencia. Editar abre la póliza completa: úsalo sólo cuando el ajuste no sea tan simple, porque si tocas un renglón de una cuenta de banco se genera un Pago y se mueve el saldo del banco."
                style={{ marginBottom: 20 }}
              />
              <TableItem
                size="small"
                pagination={false}
                loading={this.state.loading}
                rowKey="polizaId"
                dataSource={resultado.descuadradas}
                columns={this.getColumns()}
              />
            </>
          ))}

        <ModalItem
          title="Cuadrar Póliza"
          visible={this.state.modalCuadrar}
          onCancel={this.cerrarCuadrar.bind(this)}
          spinning={this.state.guardando}
          footer={null}
        >
          {polizaCuadrar && (
            <>
              <p>
                <strong>{polizaCuadrar.concepto}</strong>
                <br />
                Diferencia de {dineroDisabledMask(Math.abs(polizaCuadrar.diferencia))}. Se agregará
                un <strong>{polizaCuadrar.diferencia > 0 ? "abono" : "cargo"}</strong> por ese monto
                en la cuenta que elijas.
              </p>
              {/* key por poliza: al abrir el modal con otra, el form se remonta y vuelve a
                  tomar los initialValue en lugar de conservar lo que se escribio antes. */}
              <Form
                key={polizaCuadrar.polizaId}
                name="cuadrarPoliza"
                layout
                onFinish={this.cuadrarPoliza.bind(this)}
                bottom={
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Cuadrar
                  </ButtonItem>
                }
              >
                <FormItem label="Cuenta Contable" name="cuentaContableId" required margin>
                  <SelectItem placeholder="Cuenta Contable" showSearch>
                    {this.state.objetoCuentasContables}
                  </SelectItem>
                </FormItem>
                <FormItem
                  label="Concepto"
                  name="concepto"
                  required
                  margin
                  initialValue="Ajuste de balanceo"
                >
                  <InputItem placeholder="Concepto" />
                </FormItem>
              </Form>
            </>
          )}
        </ModalItem>

        <ModalEditarPoliza
          visible={this.state.modalEditar}
          polizaId={this.state.polizaEditarId}
          empresaId={this.state.empresaId}
          onCancel={() => this.setState({ modalEditar: false, polizaEditarId: null })}
          onGuardado={() => {
            this.setState({ modalEditar: false, polizaEditarId: null });
            this.consultarPolizas();
          }}
        />
      </div>
    );
  }
}

// Mismos colores que las etiquetas de estado de ModalPrevisualizarVenta
const COLOR_ESTADO_ENTREGA = { 1: "blue", 2: "orange", 3: "green" };

const OPCIONES_ESTADO_ENTREGA = Object.entries(ESTADOS_ENTREGA_VENTA).map(([estado, nombre]) => (
  <Option key={estado} value={Number(estado)}>
    {nombre}
  </Option>
));

//Ventas marcadas como entregadas (estado 2 o 3) cuyo estado no cuadra con lo entregado en sus lineas.
//Cambiar el estado aqui solo cambia la etiqueta: regresarla a "Sin entregar" hace que Ventas vuelva a
//ofrecer "Entregar" (solo lo ofrece en estado 1 o 2), y esa entrega es la que genera las salidas.
class VentasEstadoIncorrecto extends Component {
  state = {
    empresaId: null,
    empresaNombre: "",
    loading: false,
    resultado: null,
    seleccionados: [],
    estadoMasivo: "sugerido",
    aplicandoMasivo: false,
    guardandoVentaId: null,
  };

  onChangeEmpresa(empresaId, empresa) {
    this.setState({ empresaId, empresaNombre: empresa?.nombre || "", resultado: null, seleccionados: [] });
    if (!empresaId) return;
    this.consultar(empresaId);
  }

  consultar(empresaIdParametro) {
    const empresaId = empresaIdParametro || this.state.empresaId;
    if (!empresaId) {
      message.error("Selecciona una empresa");
      return;
    }
    this.setState({ loading: true, seleccionados: [] });
    axios
      .post("diagnostico/ventasEstadoIncorrecto", { empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ resultado: res.data });
        } else {
          message.error(res.data.message || "No se pudieron consultar las ventas");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudieron consultar las ventas");
      });
  }

  //Ajusta en memoria las filas ya cambiadas en lugar de volver a correr la consulta: la que quedo en su
  //estado sugerido (y sin lineas mal guardadas) ya no tiene problema y sale de la lista; la que no, se queda
  //con su estado nuevo.
  aplicarCambiosAlResultado(actualizadas) {
    const estadoPorVentaId = new Map(actualizadas.map((venta) => [String(venta.ventaId), venta.estado]));
    this.setState((state) => {
      if (!state.resultado) return null;
      const ventas = state.resultado.ventas
        .map((venta) =>
          estadoPorVentaId.has(String(venta.ventaId))
            ? { ...venta, estado: estadoPorVentaId.get(String(venta.ventaId)) }
            : venta
        )
        .filter(sigueConProblema);
      const idsVigentes = new Set(ventas.map((venta) => String(venta.ventaId)));
      return {
        resultado: { ...state.resultado, ok: ventas.length === 0, ventas },
        seleccionados: state.seleccionados.filter((ventaId) => idsVigentes.has(String(ventaId))),
      };
    });
  }

  //Regresa la promesa para que Modal.confirm deje el boton cargando mientras se guarda
  cambiarEstados(cambios) {
    return axios
      .post(
        "diagnostico/cambiarEstadoVentas",
        { empresaId: this.state.empresaId, cambios },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.error(res.data.message || "No se pudo cambiar el estado");
          return;
        }
        message.success(res.data.message || "Estado actualizado");
        if (res.data.omitidas?.length) {
          message.warning(
            `${res.data.omitidas.length} venta(s) no se cambiaron: ya no están en esta empresa, se cancelaron o son de anticipo`
          );
        }
        this.aplicarCambiosAlResultado(res.data.actualizadas || []);
      })
      .catch(() => message.error("No se pudo cambiar el estado"));
  }

  cambiarEstadoVenta(venta, estado) {
    const guardar = () => {
      this.setState({ guardandoVentaId: venta.ventaId });
      return this.cambiarEstados([{ ventaId: venta.ventaId, estado }]).then(() =>
        this.setState({ guardandoVentaId: null })
      );
    };

    if (estado === 1 && venta.salidas > 0) {
      Modal.confirm({
        title: "La venta ya tiene salidas de inventario",
        content: `${venta.serieNumero} tiene ${venta.salidas} salida(s) registradas. Si la regresas a "Sin entregar" y la vuelves a entregar, el inventario se descontará dos veces.`,
        okText: "Cambiar de todos modos",
        okButtonProps: { danger: true },
        cancelText: "Cancelar",
        onOk: guardar,
      });
      return;
    }
    guardar();
  }

  aplicarMasivo() {
    const { seleccionados, estadoMasivo, resultado } = this.state;
    const idsSeleccionados = new Set(seleccionados.map(String));
    const seleccionadas = (resultado?.ventas || []).filter((venta) => idsSeleccionados.has(String(venta.ventaId)));
    if (!seleccionadas.length) return;

    //Con "Estado sugerido" cada venta lleva el suyo; las que no tienen (todas sus lineas mal guardadas) se saltan
    const ventasSeleccionadas =
      estadoMasivo === "sugerido" ? seleccionadas.filter((venta) => venta.estadoSugerido) : seleccionadas;
    const sinSugerido = seleccionadas.length - ventasSeleccionadas.length;
    if (!ventasSeleccionadas.length) {
      message.warning("Ninguna de las seleccionadas tiene estado sugerido: revisa sus líneas o elige un estado");
      return;
    }

    const cambios = ventasSeleccionadas.map((venta) => ({
      ventaId: venta.ventaId,
      estado: estadoMasivo === "sugerido" ? venta.estadoSugerido : estadoMasivo,
    }));
    const conSalidas = ventasSeleccionadas.filter(
      (venta, indice) => cambios[indice].estado === 1 && venta.salidas > 0
    ).length;

    Modal.confirm({
      title: "Cambiar estado",
      content: (
        <>
          <p>
            Se cambiará el estado de {cambios.length} venta(s) a{" "}
            {estadoMasivo === "sugerido" ? "su estado sugerido" : `"${ESTADOS_ENTREGA_VENTA[estadoMasivo]}"`}.
          </p>
          {sinSugerido > 0 && (
            <p>
              Se omiten {sinSugerido} sin estado sugerido (todas sus líneas están mal guardadas).
            </p>
          )}
          {conSalidas > 0 && (
            <p style={{ color: "#cf1322" }}>
              {conSalidas} de ellas ya tienen salidas de inventario: si se regresan a "Sin entregar" y se
              vuelven a entregar, el inventario se descontará dos veces.
            </p>
          )}
        </>
      ),
      okText: "Cambiar",
      cancelText: "Cancelar",
      onOk: () => {
        this.setState({ aplicandoMasivo: true });
        return this.cambiarEstados(cambios).then(() => this.setState({ aplicandoMasivo: false }));
      },
    });
  }

  getColumns() {
    return [
      { title: "Folio", dataIndex: "serieNumero", key: "serieNumero" },
      {
        title: "Tipo",
        dataIndex: "factura",
        key: "tipo",
        render: (_, row) => <Tag color={row.factura ? "blue" : "default"}>{tipoVenta(row)}</Tag>,
      },
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        render: (value) => (value ? moment(value).locale("es").format("L") : ""),
      },
      { title: "Cliente", dataIndex: "nombreCliente", key: "nombreCliente" },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        align: "right",
        render: (value) => dineroDisabledMask(value),
      },
      {
        title: "Líneas completas",
        dataIndex: "lineasCompletas",
        key: "lineasCompletas",
        render: (_, row) => (
          <>
            {`${row.lineasCompletas} / ${row.totalLineas}`}
            {row.lineasInvalidas > 0 && (
              <Tag color="red" style={{ marginLeft: 6 }}>
                {row.lineasInvalidas} mal guardada(s)
              </Tag>
            )}
          </>
        ),
      },
      {
        title: "Cant. / Entregado",
        dataIndex: "entregadoTotal",
        key: "entregadoTotal",
        render: (_, row) => `${row.cantidadTotal} / ${row.entregadoTotal}`,
      },
      {
        title: "Salidas",
        dataIndex: "salidas",
        key: "salidas",
        render: (value, row) =>
          tieneSalidasSinEntrega(row) ? <Tag color="red">{value} - Tiene salidas</Tag> : value,
      },
      {
        title: "Sugerido",
        dataIndex: "estadoSugerido",
        key: "estadoSugerido",
        render: (value) =>
          ESTADOS_ENTREGA_VENTA[value] ? (
            <Tag color={COLOR_ESTADO_ENTREGA[value]}>{ESTADOS_ENTREGA_VENTA[value]}</Tag>
          ) : (
            <Tag color="red">{TEXTO_SIN_SUGERIDO}</Tag>
          ),
      },
      {
        // dataIndex "accion" exacto: si no, TableItem le mete ellipsis a la celda y recorta el select.
        title: "Estado",
        dataIndex: "accion",
        key: "accion",
        width: 210,
        render: (_, row) => (
          <SelectItem
            noBuscar
            noFocusSiguiente
            value={row.estado}
            loading={this.state.guardandoVentaId === row.ventaId}
            style={{ width: "100%" }}
            onChange={(estado) => this.cambiarEstadoVenta(row, estado)}
          >
            {OPCIONES_ESTADO_ENTREGA}
          </SelectItem>
        ),
      },
    ];
  }

  render() {
    const { resultado, seleccionados } = this.state;
    return (
      <div style={{ padding: 20 }}>
        <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 20 }}>
          <SelectEmpresasBiwoItem
            style={{ width: 320 }}
            placeholder="Seleccionar empresa"
            onChange={(empresaId, empresa) => this.onChangeEmpresa(empresaId, empresa)}
          />
          <ButtonItem
            loading={this.state.loading}
            disabled={!this.state.empresaId}
            onClick={() => this.consultar()}
          >
            Consultar
          </ButtonItem>
        </div>

        {resultado &&
          (resultado.ok ? (
            <Alert
              type="success"
              showIcon
              message="El estado de todas las ventas entregadas cuadra con lo entregado en sus líneas"
            />
          ) : (
            <>
              <Alert
                type="warning"
                showIcon
                message={`${resultado.ventas.length} venta(s) con un estado que no cuadra con lo entregado o con líneas mal guardadas`}
                description='Cambiar el estado aquí sólo cambia la etiqueta de la venta: no mueve inventario ni pólizas. Regresarla a "Sin entregar" hace que Ventas vuelva a ofrecer "Entregar", y esa entrega genera las salidas de inventario. Cuidado con las marcadas "Tiene salidas": ya descontaron inventario. Las líneas "mal guardadas" tienen la cantidad o lo entregado en un formato que no es número: no cuentan para el estado sugerido y hay que revisarlas a mano.'
                style={{ marginBottom: 20 }}
              />
              <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
                <SelectItem
                  noBuscar
                  noFocusSiguiente
                  value={this.state.estadoMasivo}
                  style={{ width: 240 }}
                  onChange={(estadoMasivo) => this.setState({ estadoMasivo })}
                >
                  <Option key="sugerido" value="sugerido">
                    Estado sugerido
                  </Option>
                  {OPCIONES_ESTADO_ENTREGA}
                </SelectItem>
                <ButtonItem
                  loading={this.state.aplicandoMasivo}
                  disabled={!seleccionados.length}
                  onClick={() => this.aplicarMasivo()}
                >
                  Aplicar a seleccionadas ({seleccionados.length})
                </ButtonItem>
                <ButtonItem
                  blanco
                  icon={<FileExcelOutlined />}
                  onClick={() =>
                    descargarExcelVentasEstadoIncorrecto({
                      ventas: resultado.ventas,
                      empresaNombre: this.state.empresaNombre,
                    })
                  }
                >
                  Descargar Excel
                </ButtonItem>
              </div>
              <TableItem
                size="small"
                loading={this.state.loading}
                rowKey="ventaId"
                dataSource={resultado.ventas}
                columns={this.getColumns()}
                rowSelection={{
                  selectedRowKeys: seleccionados,
                  onChange: (llaves) => this.setState({ seleccionados: llaves }),
                  //TableItem pagina de 100 en 100: SELECTION_ALL selecciona todo el resultado, no solo la pagina
                  selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
                }}
              />
            </>
          ))}
      </div>
    );
  }
}

class Diagnostico extends Component {
  render() {
    return (
      <>
        <PageHeader
          title="Diagnóstico de Empresas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div style={{ backgroundColor: "white", borderRadius: 12, boxShadow: "0 2px 10px rgba(0,0,0,0.07)", border: "1px solid rgb(235, 237, 240)" }}>
          <Tabs defaultActiveKey="ejecutar" style={{ padding: "0 20px" }}>
            <TabPane tab="Ejecutar Ahora" key="ejecutar">
              <EjecutarAhora headersToken={this.props.headersToken} />
            </TabPane>
            <TabPane tab="Cuadrar Pólizas" key="cuadrarPolizas">
              <CuadrarPolizas headersToken={this.props.headersToken} />
            </TabPane>
            <TabPane tab="Estado de Ventas" key="estadoVentas">
              <VentasEstadoIncorrecto headersToken={this.props.headersToken} />
            </TabPane>
            <TabPane tab="Configurar Cron" key="configurar">
              <ConfigurarCron headersToken={this.props.headersToken} />
            </TabPane>
            <TabPane tab="Cron Inventario" key="cronInventario">
              <ConfigurarCronInventario headersToken={this.props.headersToken} />
            </TabPane>
          </Tabs>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(Diagnostico);
